



























































































































import Vue from 'vue';
import axios from 'axios';

export default Vue.extend({
    name: 'Settings',
    data() {
        return {
            activeTab: 'account',
            formData: {
                dateFormat: 'yyyy-mm-dd',
                accountName: ''
            },
            users: [] as any[],
            inviteModalOpen: false,
            inviteEmail: '',
            inviteRole: 'GeneralUser',
            inviteError: '',
            uploadFolder: { id: null as string | null, name: '' },
            folderModalOpen: false,
            folderPath: [] as any[],
            folderList: [] as any[],
            folderLoading: false
        }
    },
    async created() {
        await axios.get(`${this.$store.state.apiUrl}/settings`)
            .then(resp => {
                this.formData.dateFormat = resp.data.DateFormat;
                this.formData.accountName = resp.data.AccountName || '';
                this.uploadFolder = { id: resp.data.UploadFolderId || null, name: resp.data.UploadFolderName || '' };
            })
            .catch(e => {
                console.log(e);
            })
        this.loadUsers();
        this.$store.state.routeLoaded = true;
    },
    methods: {
        saveSettings() {
            axios.post(`${this.$store.state.apiUrl}/settings`, this.formData)
                .then(resp => {
                    alert('Settings have been updated');
                    (this.$parent as any).checkSession();
                })
                .catch(e => {
                    alert('There was an error')
                })
        },
        loadUsers() {
            axios.get(this.$store.state.apiUrl + '/team/users')
                .then(resp => {
                    this.users = resp.data;
                })
                .catch(e => {
                    console.log(e);
                });
        },
        openInviteModal() {
            this.inviteEmail = '';
            this.inviteRole = 'GeneralUser';
            this.inviteError = '';
            this.inviteModalOpen = true;
        },
        sendInvite() {
            this.inviteError = '';
            axios.post(this.$store.state.apiUrl + '/team/invite', {
                email: this.inviteEmail,
                accountRole: this.inviteRole
            })
                .then(() => {
                    this.inviteModalOpen = false;
                    this.loadUsers();
                })
                .catch(e => {
                    this.inviteError = e.response ? e.response.data : 'There was an error sending that invite.';
                });
        },
        updateRole(user: any, accountRole: string) {
            axios.put(this.$store.state.apiUrl + '/team/users/' + user.UserId, { accountRole })
                .then(() => {
                    user.AccountRole = accountRole;
                })
                .catch(e => {
                    alert(e.response ? e.response.data : 'There was an error.');
                });
        },
        removeUser(user: any) {
            axios.delete(this.$store.state.apiUrl + '/team/users/' + user.UserId)
                .then(() => {
                    this.users = this.users.filter((u: any) => u.UserId !== user.UserId);
                })
                .catch(e => {
                    alert(e.response ? e.response.data : 'There was an error.');
                });
        },
        install() {
            axios.get(this.$store.state.apiUrl + '/hsmodule/install')
                .then(() => {
                    alert("The installation was a success!");
                })
                .catch(e => {
                    alert("There was an error. Check to see if the module is already there first and contact support for further assistance.")
                })
        },
        openFolderModal() {
            this.folderPath = [{ id: null, name: 'Root' }];
            this.folderModalOpen = true;
            this.fetchFolders();
        },
        fetchFolders() {
            this.folderLoading = true;
            const current = this.folderPath[this.folderPath.length - 1];
            const params: any = {};
            if(current.id) params.parentFolderId = current.id;
            axios.get(this.$store.state.apiUrl + '/settings/hubspot-folders', { params })
                .then(resp => {
                    this.folderList = resp.data;
                    this.folderLoading = false;
                })
                .catch(e => {
                    this.folderLoading = false;
                    alert('There was an error loading folders from HubSpot.');
                });
        },
        navigateIntoFolder(folder: any) {
            this.folderPath.push({ id: folder.id, name: folder.name });
            this.fetchFolders();
        },
        navigateToBreadcrumb(index: number) {
            this.folderPath = this.folderPath.slice(0, index + 1);
            this.fetchFolders();
        },
        selectCurrentFolder() {
            const current = this.folderPath[this.folderPath.length - 1];
            axios.post(this.$store.state.apiUrl + '/settings/upload-folder', { folderId: current.id, folderName: current.name })
                .then(() => {
                    this.uploadFolder = { id: current.id, name: current.name };
                    this.folderModalOpen = false;
                })
                .catch(e => {
                    alert('There was an error saving that folder.');
                });
        },
        clearUploadFolder() {
            axios.post(this.$store.state.apiUrl + '/settings/upload-folder', { folderId: null, folderName: null })
                .then(() => {
                    this.uploadFolder = { id: null, name: '' };
                })
                .catch(e => {
                    alert('There was an error clearing that setting.');
                });
        }
    }
})
